export const rankingTableConfig = {
  propList: [
    {prop: 'name', label: '名称', minWidth: '60'},
    {prop: 'accessCount', label: '访问次数', minWidth: '60'},
    {prop: 'rank', label: '排行', minWidth: '60'}
  ]
}
